module.exports = __webpack_public_path__ + "static/media/icon_smallplans.7f85dddb.svg";